var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "150.000000pt",
    height: "150.000000pt",
    viewBox: "0 0 150.000000 150.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,150.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M771 1304 c-20 -25 -21 -39 -21 -284 0 -245 1 -259 21 -284 l20 -26 270 0 c256 0 270 1 289 20 29 29 26 74 -6 99 -25 20 -39 21 -240 21 l-214 0 0 214 c0 201 -1 215 -21 240 -13 17 -30 26 -49 26 -19 0 -36 -9 -49 -26z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1050 1153 c-53 -19 -82 -89 -60 -143 27 -66 118 -85 170 -35 37 35 45 73 26 118 -21 52 -84 79 -136 60z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200 724 c-32 -14 -50 -38 -50 -69 0 -62 11 -65 258 -65 l222 0 0 -216 c0 -133 4 -223 11 -235 25 -47 95 -42 118 8 15 33 15 503 0 537 -7 14 -19 28 -28 31 -21 9 -512 17 -531 9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.d8aeef5fa306ffd7626af267d75c357e.svg";
export { ForwardRef as ReactComponent };